import React, { useState } from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import anaUtils from 'analytics/utils';
import {
    Box, Grid, Text, Link
} from 'components/ui';
import Answer from 'components/ProductPage/QuestionsAndAnswers/Answer/Answer';
import dateUtils from 'utils/Date';
import UrlUtils from 'utils/Url';
import languageLocale from 'utils/LanguageLocale';
import QuestionsAndAnswersEN from 'components/ProductPage/QuestionsAndAnswers/locales/QuestionsAndAnswers_en_US';
import QuestionsAndAnswersFR from 'components/ProductPage/QuestionsAndAnswers/locales/QuestionsAndAnswers_fr_CA';

const getText = languageLocale.getLocalisedDataFromResource(QuestionsAndAnswersEN, QuestionsAndAnswersFR);

let scrollPos;

const Question = ({
    productId, userNickname, questionDetails, submissionTime, answers = [], questionId, skuId
}) => {
    const [showMoreAnswers, setShowMoreAnswers] = useState(false);

    const processPostedDate = postedDate => dateUtils.formatSocialDate(postedDate, true);

    const getPostedBy = nickname => (nickname ? getText('postedBy', [nickname]) : '');

    const getAnswersToShow = () => {
        let answersToShow = answers.slice(0, 1);

        if (showMoreAnswers) {
            answersToShow = answers;
        }

        return answersToShow;
    };

    const redirectToSubmitAnswerPage = () => {
        anaUtils.setNextPageData({ linkData: 'answer this question' });
        const PRODUCT_SUBMIT_ANSWER_URL = `/submitAnswer?productId=${productId}&questionId=${questionId}&skuId=${skuId}`;

        return UrlUtils.redirectTo(PRODUCT_SUBMIT_ANSWER_URL);
    };

    const answersToShow = getAnswersToShow();

    const answerLink = (
        <Box marginTop={4}>
            <Link
                padding={2}
                margin={-2}
                color='blue'
                onClick={() => redirectToSubmitAnswerPage()}
                data-at={Sephora.debug.dataAt('answer_link')}
                children={getText('answerThisQuestion')}
            />
        </Box>
    );

    const moreAnswersLink = answers.length > 1 && (
        <Link
            padding={2}
            margin={-2}
            arrowDirection={!showMoreAnswers ? 'down' : 'up'}
            onClick={() => {
                if (!showMoreAnswers) {
                    scrollPos = window.scrollY;
                }

                setShowMoreAnswers(!showMoreAnswers);

                if (showMoreAnswers) {
                    window.scroll(0, scrollPos);
                }
            }}
            children={!showMoreAnswers ? getText('moreAnswers', [answers.length - 1]) : getText('showLess')}
        />
    );

    return (
        <div>
            <Grid
                columns='1.5em 1fr'
                gap={null}
                data-at={Sephora.debug.dataAt('questions_section')}
            >
                <Text
                    aria-label={getText('question')}
                    fontWeight='medium'
                    children='Q:'
                />
                <div>
                    <Text
                        is='h4'
                        fontWeight='medium'
                        lineHeight='relaxed'
                        children={questionDetails}
                    />
                    <Text
                        is='p'
                        fontSize={['sm', 'base']}
                        color='gray'
                        data-at={Sephora.debug.dataAt('QuestionAskedTime')}
                        children={`${getText('asked')} ${processPostedDate(submissionTime)} ${getPostedBy(userNickname)}`}
                    />
                    {answers.length === 0 && answerLink}
                </div>
            </Grid>
            {answers.length > 0 &&
                answersToShow.map((item, index) => (
                    <Answer
                        key={item.answerId}
                        productId={productId}
                        {...item}
                        {...(index === answersToShow.length - 1 && {
                            answerLink,
                            moreAnswersLink
                        })}
                    />
                ))}
        </div>
    );
};

export default wrapFunctionalComponent(Question, 'Question');
